import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconClock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.5 0C3.375 0 0 3.375 0 7.5C0 11.625 3.375 15 7.5 15C11.625 15 15 11.625 15 7.5C15 3.375 11.625 0 7.5 0ZM7.5 13.125C4.40625 13.125 1.875 10.5938 1.875 7.5C1.875 4.40625 4.40625 1.875 7.5 1.875C10.5938 1.875 13.125 4.40625 13.125 7.5C13.125 10.5938 10.5938 13.125 7.5 13.125Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.4375 3.75H6.5625V8.4375H11.25V6.5625H8.4375V3.75Z",
		fill: "currentColor"
	})]
});
export default SvgIconClock;
